<template>
  <section id="admin-equipment-view">
    <content-header :prev="{name: 'Admin'}" :sticky="true" title="Equipment" />

    <nav class="admin-equipment-nav">
      <router-link
        :to="{name: 'Admin: Equipment Categories'}"
        v-slot="{ href, route, navigate }"
        v-if="hasAdmin('EQUIPMENT_CATEGORIES') || hasAdmin('EQUIPMENT_SUBCATEGORIES') || hasAdmin('EQUIPMENT_ITEMS')"
      >
        <a
          :class="['admin-equipment-nav-link', isExactActive(route) && 'router-link-exact-active', isActive(route) && 'router-link-active']"
          :href="href"
          @click="navigate"
        >
          <img alt="Categories &amp; Subcategories" src="../../assets/icons/equipment-category.svg" />
        </a>
      </router-link>

      <router-link
        :to="{name: 'Admin: Equipment Manufacturers'}"
        v-slot="{ href, route, navigate }"
        v-if="hasAdmin('MANUFACTURERS') || hasAdmin('VENDORS')"
      >
        <a
          :class="['admin-equipment-nav-link', isExactActive(route) && 'router-link-exact-active', isActive(route) && 'router-link-active']"
          :href="href"
          @click="navigate"
        >
          <img alt="Manufacturers &amp; Suppliers" src="../../assets/icons/manufacturer.svg" />
        </a>
      </router-link>

      <router-link
        :to="{name: 'Admin: Equipment Specifications'}"
        v-slot="{ href, route, navigate }"
        v-if="hasAdmin('EQUIPMENT_PARTS') || hasAdmin('EQUIPMENT_ACCESSORIES')"
      >
        <a
          :class="['admin-equipment-nav-link', isExactActive(route) && 'router-link-exact-active', isActive(route) && 'router-link-active']"
          :href="href"
          @click="navigate"
        >
          <img
            alt="Specifications &amp; Accessories"
            src="../../assets/icons/equipment-specification.svg"
          />
        </a>
      </router-link>

      <router-link
        :to="{name: 'Admin: Equipment Statuses'}"
        v-slot="{ href, route, navigate }"
        v-if="hasAdmin('EQUIPMENT_PARTS')"
      >
        <a
          :class="['admin-equipment-nav-link', isExactActive(route) && 'router-link-exact-active', isActive(route) && 'router-link-active']"
          :href="href"
          @click="navigate"
        >
          <img
            alt="Statuses"
            src="../../assets/icons/equipment-status.svg"
          />
        </a>
      </router-link>
    </nav>

    <router-view />
  </section>
</template>

<script>
import PartialView from "./PartialView";

export default {
  data() {
    return {
      view: "",
    };
  },

  methods: {
    isActive(route) {
      return (
        route.name === this.$route.name &&
        route.matched[route.matched.length - 1].regex.test(this.$route.path)
      );
    },
    isExactActive(route) {
      return (
        this.isActive(route) && route.params.view === this.$route.params.view
      );
    },
  },

  created() {
    this.view = this.$route.params.view ?? "";
  },

  beforeRouteUpdate(to, from, next) {
    this.abortRequests();

    next((vm) => {
      vm.view = to.params.view ?? "";
    });
  },

  beforeRouteLeave(to, from, next) {
    this.abortRequests();
    next();
  },

  components: {
    PartialView,
  },
};
</script>

<style>
#admin-equipment-view {
  display: flex;
  flex-wrap: wrap;
}

#admin-equipment-view .admin-equipment-nav {
  align-self: flex-start;
  grid-area: nav;
  position: sticky;
  top: 3.375rem;
  transform: translateX(-1rem);
  width: auto;
}

#admin-equipment-view .admin-equipment-nav-link {
  align-items: center;
  background-image: radial-gradient(
    circle at 0 3em,
    var(--primary-medium-gray) 3em,
    transparent 3.1em
  );
  background-repeat: no-repeat;
  display: flex;
  grid-area: tab;
  height: 6em;
  justify-content: center;
  justify-self: flex-start;
  padding-right: 12%;
  width: 3.1em;
}

#admin-equipment-view .admin-equipment-nav-link img {
  filter: var(--filter-primary-white);
  max-height: 3em;
  max-width: 2em;
}

#admin-equipment-view .admin-equipment-nav-link:hover {
  background-image: radial-gradient(
    circle at 0 3em,
    var(--primary-dark-gray) 3em,
    transparent 3.1em
  );
}

#admin-equipment-view .admin-equipment-nav-link.router-link-active {
  background-image: radial-gradient(
    circle at 0 3em,
    var(--primary-black) 3em,
    transparent 3.1em
  );
}

#admin-equipment-view .admin-table {
  grid-area: table;
}

#admin-equipment-view .admin-form-wrapper {
  grid-area: form;
}

#admin-equipment-view
  .admin-content-partial:not(#admin-equipment-items)
  .admin-form-tab
  img {
  max-width: 2em;
}
</style>